import React from "react";
import { insertTextbeforeUrlExtention } from "../utils/general/text-formatting.js";
// import { page_links } from "../utils/config/page-links.js";
// import { handleScaleInlineTailwind300 } from "../utils/animations/animations.js";


import {
  bullet_point_logo_white,
  b_roll_urls,
} from "../utils/config/image-links.js";
import {
  res_bullet_point_castell_logo,
  res_about_us_block_image,
} from "../utils/config/image-resolutions.js";
import { our_culture } from "../utils/config/text-blocks.js";
import { ImageLoader } from "../components/ImageLoaders.jsx";

export default function Vacancies() {
  // const buttonRefs = useRef([]);
  // const { vacancyDepartments, selectedVacancyDepartment, setSelectedVacancyDepartment } = useContext(UserContext);

  // const throttledMouseMove = useRef(handleMouseMove(buttonRefs));
  // eslint-disable-next-line
  // const handleMouseMoveCallback = useCallback(throttledMouseMove.current, []);
  // // eslint-disable-next-line
  // const handleMouseLeaveCallback = useCallback(handleMouseLeave(buttonRefs, throttledMouseMove.current), []);

  return (
    <div className="flex flex-col lg:px-[20%] px-[10%] py-12 bg-white gap-16">
      <div className="flex flex-col gap-4 p-8 w-full border border-gray-200 shadow-xl rounded-lg text-lg">
        <h1 className="text-2xl font-semibold text-castell">Disclaimer: Unsolicited CVs – Recruitment Agencies</h1>
        <p>
          Castell Group and its subsidiaries have an internal recruiting team. Agencies are hereby specifically directed
          not to contact Castell’s coworkers directly to present candidates – Castell’s Recruiting Team must present all
          candidates to hiring managers.
        </p>
        <p>
          To protect the interests of all parties, Castell Group will not accept unsolicited CVs from any source other
          than directly from a candidate. Castell Group will not pay any introduction fee’s for any placement resulting
          from the receipt of an unsolicited CV. Castell Group will consider any candidate for whom an Agency has
          submitted an unsolicited CV to have been referred by the Agency free of any charges or fees.
        </p>
        <p>
          Agencies must obtain advance written approval from Castell’s Recruiting Team to submit CVs, and then only in
          conjunction with Castell’s agreed payment terms and placement fee. Castell Group will not pay a fee to any
          Agency that does not have such agreement in place.
        </p>
      </div>

      
      {/* CASTELL CAREERS */}
      <div className="flex flex-col-reverse xl:flex-row px-[5%] bg-gradient-to-r from-castell to-castellpastel-800 text-white items-center py-8 xl:py-16 gap-8 xl:gap-12">
        <div className="flex flex-col xl:w-[50%] gap-4">
          <div className="text-2xl xl:text-3xl">
            Castell Careers - We offer an exciting, fast paced and supportive working environment
          </div>
          <div className="text-lg xl:text-xl">
            Each person within the business represents the cornerstones of our culture:
          </div>

          <div className="flex flex-col gap-4">
            {our_culture.map((value, index) => (
              <div key={index} className="flex flex-row gap-4 text-base xl:text-lg  items-center">
                <img
                  src={insertTextbeforeUrlExtention(bullet_point_logo_white, res_bullet_point_castell_logo)}
                  alt={`logo`}
                  className={`w-8`}
                />
                {value}
              </div>
            ))}
          </div>
          {/* <div className="flex w-full justify-center">
            <button
              aria_label="View Castell Vacancies"
              className={`px-12 py-2 hover:bg-white hover:text-castell mt-4 font-semibold whitespace-nowrap text-left border border-white rounded-sm ${handleScaleInlineTailwind300}`}
              onClick={() => (window.location.href = page_links["vacancy"].link)}
              onMouseEnter={(e) => e.currentTarget.classList.add("scale-110")}
              onMouseLeave={(e) => e.currentTarget.classList.remove("scale-110")}
            >
              Castell Vacancies
            </button>
          </div> */}
        </div>
        <ImageLoader
          src={insertTextbeforeUrlExtention(b_roll_urls[16], res_about_us_block_image)}
          alt={"Bricklayer laying bricks"}
          containerClass="flex w-full xl:w-[50%] h-full rounded-2xl overflow-hidden shadow-2xl border-2 border-white border-opacity-25"
          imageClass="w-full h-48 md:h-64 lg:h-80 xl:h-96 object-cover"
        />
      </div>

      <div
        className="flex flex-grow border-none border-radius-3px items-center justify-center"
      >
        <div className="flex flex-col gap-4">
          <h2 className="text-2xl font-semibold text-castell">Vacancies</h2>
          <p className="text-lg">
            For any vacancies, please send the following details to <b><a href="mailto:recruitment@castellgroup.co.uk" className="text-castell underline">recruitment@castellgroup.co.uk</a></b>:
          </p>
          <ul className="list-disc list-inside pl-4">
            <li>Name</li>
            <li>Role of interest</li>
            <li>Location</li>
            <li>Experience (CV)</li>
          </ul>
          <p className="text-lg">
            For available opportunities, please visit our <b><a href="https://www.linkedin.com/company/castellgroup/" target="_blank" className="text-castell underline">LinkedIn</a></b> page.
          </p>
        </div>
      </div>

      {/* <iframe
        className="flex flex-grow border-none border-radius-3px"
        src="https://api.leadconnectorhq.com/widget/form/qTfWv2mQImljSQVTB1BH"
        //style="width:100%;height:100%;border:none;border-radius:3px"
        id="inline-qTfWv2mQImljSQVTB1BH"
        data-layout="{'id':'INLINE'}"
        data-trigger-type="alwaysShow"
        data-trigger-value=""
        data-activation-type="alwaysActivated"
        data-activation-value=""
        data-deactivation-type="neverDeactivate"
        data-deactivation-value=""
        data-form-name="Vacancy Form"
        data-height="1405"
        data-layout-iframe-id="inline-qTfWv2mQImljSQVTB1BH"
        data-form-id="qTfWv2mQImljSQVTB1BH"
        title="Vacancy Form"
            >
      </iframe>
      <script src="https://link.msgsndr.com/js/form_embed.js"></script> */}

      {/* <div className="flex flex-col border border-gray-200 shadow-xl rounded-lg p-4 sm:p-8 gap-6">
        <div className="flex w-full text-2xl font-semibold text-castell justify-center lg:justify-start border-b border-gray-200 pb-4">
          Vacancies
        </div>
        <div className="flex flex-col lg:flex-row gap-4 sm:gap-8">
          <div className="hidden lg:flex flex-col gap-2">
            {vacancyDepartments.map((department) => (
              <button
                aria-label={`Filter vacancies by ${department.name}`}
                key={department.id}
                className={`px-4 py-2 ${
                  department.id === selectedVacancyDepartment.id
                    ? "bg-castell text-white"
                    : "hover:bg-castellpastel-100"
                } font-semibold whitespace-nowrap text-left w-full border border-gray-200 rounded-sm ${handleScaleInlineTailwind300}`}
                onClick={() => setSelectedVacancyDepartment(department)}
                onMouseEnter={(e) => e.currentTarget.classList.add("scale-110")}
                onMouseLeave={(e) => e.currentTarget.classList.remove("scale-110")}
              >
                {department.name}
              </button>
            ))}
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 w-full h-full gap-4 sm:gap-8 text-black font-semibold text-xs md:text-sm">
            {Object.values(vacancies_data)
              .filter((vacancy) => vacancy.active === true)
              .filter((vacancy) =>
                selectedVacancyDepartment.id === "all"
                  ? vacancy
                  : vacancy.department.id === selectedVacancyDepartment.id
              )
              .map((vacancy, index) => (
                <button
                  aria-label={`View ${vacancy.title}`}
                  key={vacancy.id}
                  ref={(el) => (buttonRefs.current[index] = el)}
                  onClick={() => (window.location.href = `${page_links["vacancy"].link}/${vacancy.id}`)}
                  className={`flex flex-col border border-gray-200 rounded-lg overflow-hidden transition-transform duration-150 shadow-lg`}
                  onMouseMove={(e) => handleMouseMoveCallback(e, index)}
                  onMouseLeave={() => handleMouseLeaveCallback(index)}
                >
                  <DivWithLoadingBackground
                    className="flex w-full h-52 2xl:h-64 bg-cover border-b border-gray-200 bg-center bg-blue-200"
                    imageUrl={insertTextbeforeUrlExtention(vacancy.image.image_url || template_image_light, "_tinyres")}
                  />
                  <div className="flex flex-col w-full items-center px-2 py-2">
                    <div className="whitespace-nowrap">{vacancy.title}</div>
                  </div>
                </button>
              ))}
          </div>
        </div>
      </div> */}
    </div>
  );
}
